import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {NgSelectModule} from '@ng-select/ng-select';
import {PlanModel} from '../../common/service/plan-model.model';
import {FieldRecordLodgementTypes} from '../lodge-field-record.model';
import {isValidString} from '../../common/service/data-util';

@Component({
    selector: 'nlr-plan-field-record-lodgement',
    imports: [FormsModule, CommonModule, NgSelectModule],
    templateUrl: './field-record-lodgement.component.html',
    styleUrl: './field-record-lodgement.component.scss'
})
export class FieldRecordLodgementComponent implements OnInit {
    selectedType = undefined;
    planModel: PlanModel = undefined;
    amendmentDetailsLabel = undefined;
    submitted = false;

    @Input()
    model: PlanModel;

    @Input()
    lodgeTypes: FieldRecordLodgementTypes[];

    @Output()
    modelChanged = new EventEmitter<PlanModel>();

    @Output()
    validationChanged = new EventEmitter<boolean>();

    ngOnInit(): void {
        console.info('$onInit');
        this.model.lodgeType = undefined;
    }

    isLodgeTypeValid() {
        return this.model.lodgeType === undefined || this.model.lodgeType === '' ? false : true;
    }

    isAmendmentDetailsInValid(){
        return !(this.isLodgeTypeValid() && isValidString(this.model.amendmentDetails)) && this.submitted;
    }


    getAmendmentDetailsLabel() {
        if (this.model.lodgeType) {
            const selectedLodgementType = this.lodgeTypes.filter(v => {
                return v.id === this.model.lodgeType;
            })[0];

            if (selectedLodgementType) {
                return selectedLodgementType.amendmentDetailsLabel;
            }
        }

        return '';
    }

    getLodgeType(): string {
        if (this.lodgeTypes.length > 0 && this.model.lodgeType) {
            return this.lodgeTypes.filter(v => {
                return v.id === this.model.lodgeType;
            })[0].name;
        }
        return '';
    }

    updateSelectedOption(option: string): void {
        this.model.lodgeType = option;
        if (this.model.lodgeType) this.validationChanged.emit(isValidString(this.model.lodgeType));
    }

    onAmdDtlChange(newValue: string) {
        this.model.amendmentDetails = newValue;
    }

    onReceiptEmailChange(newValue: string) {
        this.model.lodgementReceiptEmailAddress = newValue;
    }

    onCustReferenceChange(newValue: string) {
        this.model.customerReference = newValue;
    }
}
